import { render, staticRenderFns } from "./UserLogoutModal.vue?vue&type=template&id=4badbf76&scoped=true&"
import script from "./UserLogoutModal.vue?vue&type=script&lang=ts&"
export * from "./UserLogoutModal.vue?vue&type=script&lang=ts&"
import style0 from "./UserLogoutModal.vue?vue&type=style&index=0&id=4badbf76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4badbf76",
  null
  
)

export default component.exports